exports = module.exports = require("../../../../../../../../home/el/code/sverkasoft-erp/frontend/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"WorkTypeSelect.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/css-loader?{"sourceMap":true}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bdaff5f4","scoped":true,"hasInlineConfig":false}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Catalogs/WorkType/WorkTypeSelect.vue
// module id = U/PP
// module chunks = 0